<template>
    <div class="ui-list-card">
        <div v-if="$slots.header" class="ui-list-card__header">
            <slot name="header" />
        </div>
        <div v-if="!empty" class="ui-list-card__items">
            <slot />
        </div>
        <div v-else class="ui-list-card__empty">
            <slot name="empty" />
        </div>
    </div>
</template>

<script setup lang="ts">
interface Props {
    empty?: boolean;
}

withDefaults(defineProps<Props>(), {
    empty: false,
});
</script>
